import { Button } from 'components/common'
import { Table, TableCell, TableRow } from 'components/common/minimalTable'
import { useNavigate } from 'react-router-dom'
import { Rma } from 'types/order'
import { PAGE_RMA_DETAILS } from 'utils/constants'

interface RmaListProps {
  isFullRma: boolean
  rmaList: Rma[]
}

const RmaList = ({ isFullRma, rmaList }: RmaListProps) => {
  const navigate = useNavigate()

  const redirectToViewRma = (rmaId: string) => {
    navigate(`${PAGE_RMA_DETAILS.path}/${rmaId}`)
  }

  return (
    <Table headers={['RMA Number', 'Type', 'RMA Created By', 'View RMA']}>
      {rmaList.map((rma: Rma) => (
        <TableRow key={rma._id}>
          <TableCell>{rma?.rmaNo ?? 'NA'}</TableCell>
          <TableCell>
            {rma?.isFullRMA ?? isFullRma ? 'Full RMA' : 'Partial RMA'}
          </TableCell>
          <TableCell>{rma?.createdBy ?? '-'}</TableCell>
          <TableCell>
            <Button
              buttonText="View"
              type="button"
              size="small"
              className="bg-gray-800 hover:border-gray-800 hover:text-gray-800"
              onClick={() => redirectToViewRma(rma._id)}
            />
          </TableCell>
        </TableRow>
      ))}
    </Table>
  )
}

const TableRmaHistory = ({
  rmaList,
  isFullRmaGenerated,
}: {
  rmaList: Rma[]
  isFullRmaGenerated: boolean
}) => {
  return (
    <>
      <h3 className="title mt-3">RMA History</h3>

      {rmaList?.length > 0 ? (
        <RmaList isFullRma={isFullRmaGenerated} rmaList={rmaList} />
      ) : (
        <p className="text-sm text-gray-600">No RMAs available</p>
      )}
    </>
  )
}

export default TableRmaHistory
